import graphql from "babel-plugin-relay/macro";

const StocksInNewsQuery = graphql`
query StocksInNewsQuery{
  allPoliticians(isInNews:true){
    edges{
      node{       
         id
        name
        politicianImage
        party{
          partyName
        }
        price
    
        
          
      }
    }
  }
}
`

export default StocksInNewsQuery
// priceDiff
// stockhistory{
// 	edges{
// 		node{
// 			created
// 			updatedPrice
// 		}
// 	}
// }
//stockOwnedCount